import React, { useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  userInfoByNumberAtom,
  userInfoFormEnableDisableAtom,
  userRawLeadFormDataAtom,
} from '../../Services/_states';
import { Box, Grid, TextField, Typography } from '@mui/material';

const UserInfo = ({ data, setData }) => {
  const [userRawLeadData, setUserRawLeadData] = useRecoilState(userRawLeadFormDataAtom);
  const [userInfo, setUserInfo] = useRecoilState(userInfoByNumberAtom);
  const [validationErrors, setValidationErrors] = useState({});
  const formEnable = useRecoilValue(userInfoFormEnableDisableAtom);

  function formatLabel(string) {
    return string
      .split('_')
      .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      .join(' ');
  }

  const handleChange = (e, obj, index) => {
    let arrData = [...userRawLeadData?.data];
    arrData[index] = { ...arrData[index], value: e?.target?.value };
    setUserRawLeadData({ ...userRawLeadData, data: arrData });
  };

  return (
    <Box component="form" sx={{ maxHeight: 240, overflowY: 'auto', p: 1 }}>
      <Grid container spacing={2}>
        {userRawLeadData?.data?.map((item, index) => {
          if (item?.Is_visible_on_frontend === 0) {
            return null;
          } else {
            switch (item?.field_type) {
              case 'String':
              case 'Location':
                return (
                  <Grid item xs={12} key={index}>
                    <Typography variant="subtitle1" sx={{ textTransform: 'capitalize', mb: 0.5 ,  color: 'text.main'}}>
                      {formatLabel(item?.alias_name)}
                      {item?.is_required === 1 && <span style={{ color: 'red' }}> *</span>}
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder={item?.column_name || 'Enter'}
                      value={item?.value || ''}
                      onChange={(e) => handleChange(e, item, index)}
                      disabled={formEnable}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                );
            }
          }
        })}
      </Grid>
    </Box>
  );
};

export default UserInfo;
